import React from 'react';
import { BooleanField, TextField, NumberField } from 'react-admin';
import DateField from './DateField';

const DefaultFields = (props) => {
	return [
		<TextField source="name" key="name" />,
		<NumberField source="index" key="index" />,
		<BooleanField source="active" key="active" />,
		<DateField source="createdAt" key="createdAt" />,
		<DateField source="updatedAt" key="updatedAt" />
	];
};

export default DefaultFields;
